import React from 'react';
import styled from 'styled-components';
import {Link, withRouter} from 'react-router-dom';

import TimeAgo from '../TimeAgo';
import Avatar from '../Avatar';

function AnswerComment({sheet, answer, children, match: {params}}) {
    return (
      <Comment>
        <Details>
          <Avatar user={sheet.user} />
          <User>
            <Link to={`/users/${sheet.user.id}`}>{sheet.user.userName}</Link>
          </User>
          <CommentDate>
            <Link to={`/sheet/${params.templateId}/${params.sheetIds}/data/${answer.rowId}`}>
              <TimeAgo date={answer.dates.lastModified} />
            </Link>
          </CommentDate>
        </Details>
        <Value>{children}</Value>
      </Comment>
    );
}

const Comment = styled.div`
  padding: 0.5rem 1.875rem 1rem 1.875rem;
  border-bottom: 1px solid #E4E4E4;
`;

const Details = styled.div`
  display: flex;
  align-items: center;
`;

const User = styled.div`
  margin-left: 1rem;
  flex: 1;
`;

const CommentDate = styled.div`
  font-size: 0.9rem;

  a, a:visited {
    color: #747474;
  }
`;

const Value = styled.p`
  margin: 0;
  margin-left: 3.5rem;
`;

export default withRouter(AnswerComment);